import React from "react";

const AboutMe = () => {
  return (
    <div className="flex flex-col md:flex-row pb-6">
      <div className="w-full md:w-1/2 text-zinc-400 px-6 border-r-[1px] border-r-zinc-800 flex items-center">
        <div className="py-6">
          <h2 className="font-semibold mb-1">Hello! I'm Syafiq Ibrahim</h2>
          <p className="text-base leading-6 ">
          a web developer who is very interested in the world of technology.
          Committed to creating quality work and always ready to accept new challenges. Enthusiastic in collaborating with diverse teams, with a humble attitude and openness to learn and grow together. Dedicated to making a positive contribution to achieving mutual success.
          </p>
        </div>
      </div>
      <div className="w-full md:w-1/2 p-6">
        <ul className="flex flex-col gap-1">
          <li className="aboutRightLi">
            <span className="aboutRightLiSpan">Age:</span>
            24
          </li>
          <li className="aboutRightLi">
            <span className="aboutRightLiSpan">Residence:</span>
            Indonesia
          </li>
          <li className="aboutRightLi">
            <span className="aboutRightLiSpan">Freelance:</span>
            Available
          </li>
          <li className="aboutRightLi">
            <span className="aboutRightLiSpan">Address:</span>
            Bekasi, Indonesia
          </li>
        </ul>
      </div>
    </div>
  );
};

export default AboutMe;
